module.exports = __webpack_public_path__ + "img/area-6-video1-cover.873cd0f.jpg";